<template>
  <v-row
    no-gutters
  >
    <v-col
      v-for="filter in filterButtons"
      :key="filter.name"
      cols="auto"
    >
      <v-chip
        :color="filter.active ? 'secondary' : ''"
        :id="`${kebabCase(filter.name)}-filter-tickets-table`"
        style="margin-bottom: 2px;"
        :small="$vuetify.breakpoint.lgAndDown"
        class="ml-1 px-2 interactive"
        :ripple="{
          class: 'grey--text'
        }"
        :outlined="!filter.active"
        @click="filterClicked(filter)"
      >
        <v-row
          no-gutters
          align="center"
        >
          <v-col
            cols="auto"
            style="margin-top: -2px;"
          >
            <Icon
              :icon="filter.icon"
              :iconColor="filter.active ? activatedFilterText : deactivatedFilterIcon"
            />
          </v-col>

          <v-col>
            <span
              :class="filter.active ? 'white--text' : ''"
              :style="filter.active ? '' : { color: deactivatedFilterText }"
            >
              {{ $t(filter.name) }}
            </span>
          </v-col>

          <v-col v-if="filter.close" cols="auto">
            <v-icon
              small
              class="ml-1"
              :color="filter.active ? activatedFilterText : deactivatedFilterText"
            >
              mdi-close-circle
            </v-icon>
          </v-col>
        </v-row>
      </v-chip>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import { kebabCase } from 'lodash'

export default {
  name: 'TicketFilterChips',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  computed: {
    ...mapGetters('ticket', ['allTickets', 'ticketsLoading', 'filters']),

    filterButtons () {
      const includeAdvancedSearch = this.filters.advancedSearch?.active
      if (includeAdvancedSearch) {
        const chip = {
          ...this.filters.advancedSearch,
          icon: 'mdi-magnify',
          close: true
        }
        return [chip]
      } else {
        const filterButtons = Object
          .values(this.filters)
          .slice(0, -5)
        return filterButtons
      }
    },

    activatedFilterText () {
      return 'white'
    },

    deactivatedFilterText () {
      return 'grey'
    },

    deactivatedFilterIcon () {
      return 'grey lighten-1'
    }
  },

  methods: {
    kebabCase,
    ...mapMutations('ticket', ['removeFilter']),
    ...mapMutations('ticket', ['applyFilter', 'removeFilter', 'setDateFilter']),

    filterClicked (filter) {
      if (filter.active) {
        this.removeFilter(filter)
      } else {
        if (filter.name !== 'dateRange') {
          this.applyFilter(filter)
        } else {
          this.dateFilter.active = true
        }
      }
    }
  }
}
</script>
